import { selectPageTitle } from '../../pageTitle/selectors';

export const setCurrentPageTitle = (state) => {
  const currentPageTitle = selectPageTitle(state);
  if (currentPageTitle) {
    document.title = currentPageTitle;
  }
  return Promise.resolve();
};
